import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  Container,
  Alert,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/system";
import AOS from "aos";
import { Navigate, useNavigate } from "react-router-dom";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import { isLoggedIn } from "../../utils/auth";
import { Styles } from "./styles";
import DarkLogo from "../../Assets/images/logo.png";
import { ability, updateAbility } from "../../config/acl/ability";

const Logo = styled("img")({
  width: "100px",
  transition: "transform 1s ease-in-out",
});

const LoginPage = ({ thememode }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (isLoggedIn()) {
  //     navigate("/Dashboard");
  //   }
  //   AOS.init({
  //     duration: 1000,
  //     easing: "ease-in-out",
  //     once: true,
  //   });
  // }, []);
  console.log(isLoggedIn());

  if (isLoggedIn()) {
    navigate("/dashboard");
  }
  const handleLogin = async (e) => {
    e.preventDefault();
    setError(""); // Reset error before login attempt
    setSuccess(false); // Reset success state

    // Check if fields are empty
    if (!username || !password) {
      setError("Both username and password are required.");
      return;
    }

    setLoading(true); // Show loading spinner

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Auth.login,
        data: {
          name: username,
          password: password,
        },
      });

      const { token, user, roles, permissions } = response;
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("roles", JSON.stringify(roles));
      localStorage.setItem("permissions", JSON.stringify(permissions));
      updateAbility(permissions);
      setSuccess(true);
      setError("");
      setLoading(false);
      navigate("/dashboard");
    } catch (err) {
      setLoading(false);
      setError(
        err.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  return (
    <Styles thememode={thememode}>
      <div className="login-page">
        <div className="login-form">
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "100vh",
              padding: 4,
            }}
          >
            <Container maxWidth="sm">
              {/* Logo */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 1,
                }}
              >
                <Logo
                  data-aos="zoom-in"
                  src={
                    thememode === "dark"
                      ? DarkLogo
                      : "https://booksmmapi.worldq8.com/static/media/main-logo.57c07897421781d9e1d47311b93320c1.svg"
                  }
                  alt="Logo"
                  style={{
                    width: "200px",
                  }}
                />
              </Box>

              {/* Title */}
              <Typography
                variant="h4"
                sx={{
                  color: "#114787",
                  fontWeight: "bold",
                  textAlign: "center",
                  marginBottom: 4,
                }}
              >
                Welcome Back
              </Typography>

              {/* Form */}
              <Box
                component="form"
                onSubmit={handleLogin}
                sx={{
                  width: "100%",
                  padding: 3,
                  borderRadius: 2,
                  boxShadow:
                    thememode === "dark"
                      ? "0px 4px 10px rgba(255, 255, 255, 0.4)"
                      : "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Error Message */}
                {error && (
                  <Alert
                    variant="filled"
                    severity="error"
                    sx={{ marginBottom: 2 }}
                  >
                    {error}
                  </Alert>
                )}

                <TextField
                  fullWidth
                  id="username"
                  label="Username"
                  placeholder="Enter your username"
                  margin="normal"
                  required
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />

                {/* Password Field */}
                <TextField
                  fullWidth
                  id="password"
                  type="password"
                  label="Password"
                  required
                  placeholder="Enter your password"
                  margin="normal"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />

                {/* Submit Button */}
                <Button
                  fullWidth
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "#114787",
                    color: "white",
                    padding: "10px 0",
                    marginTop: 2,
                    fontSize: "16px",
                    "&:hover": {
                      backgroundColor: "#0e3763",
                    },
                  }}
                >
                  {loading ? (
                    <CircularProgress size={24} sx={{ color: "white" }} />
                  ) : (
                    "Login"
                  )}
                </Button>
              </Box>
            </Container>
          </Box>
        </div>
        <div className="login-logo">
          <img src={DarkLogo} alt="logo" />
        </div>
      </div>
    </Styles>
  );
};

export default React.memo(LoginPage);
